import React, { useEffect } from "react"
import { useMsal } from "@azure/msal-react";
import { useLocation } from "react-router-dom";
import Loader from "../Components/Shared/Loader/loader";

const Logout = () => {
    const { instance, accounts, inProgress } = useMsal();
    const location = useLocation();

    useEffect(() => {
        // Wait until MSAL instance is ready (inProgress is "none")

        if (inProgress !== "none") {
            return;
        }

        // Extract redirectUrl from URL parameters
        const urlParams = new URLSearchParams(location.search);
        const redirectUrl = urlParams.get('redirectUrl');

        if (accounts.length === 0) {
            window.location.href = redirectUrl
            return;
        }

        const logoutRequest = {
            account: instance.getAccountByHomeId(accounts[0].homeAccountId),
            postLogoutRedirectUri: redirectUrl
        }

        // Perform logout - MSAL will use the registered postLogoutRedirectUri from config
        instance.logoutRedirect(logoutRequest);
    }, [instance, accounts, location, inProgress]);


    return <Loader />;
}

export default Logout
